import React, { useState } from "react";

import { GlobalLoader } from "@components/global-loader/GlobalLoader";
import { LoaderGetterContext, LoaderSetterContext } from "@state/context";

export function LoadingContainer(props: { children: React.ReactNode }) {
	const [isLoading, setIsLoading] = useState(false);

	return (
		<LoaderGetterContext.Provider value={{ isLoading }}>
			<LoaderSetterContext.Provider value={{ setIsLoading }}>
				{isLoading && <GlobalLoader />}
				{props.children}
			</LoaderSetterContext.Provider>
		</LoaderGetterContext.Provider>
	);
}
